import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-search-field',
  templateUrl: './search-field.component.html',
  styleUrls: ['./search-field.component.scss'],
})
export class SearchFieldComponent implements OnInit {
  @Input() placeholderText: string = '';
  @Output() searchCriteria = new EventEmitter<String>();
  @Input() ID = 'search-field';
  @Input() maxLength?: number;
  searchWord: String | undefined;

  constructor(private translate: TranslateService) {}
  ngOnInit() {
    this.translate.get('SEARCH').subscribe((translatedText: string) => {
      this.placeholderText = translatedText;
    });
  }

  searchThis() {
    this.searchCriteria.emit(this.searchWord);
  }

  clear() {
    this.searchWord = '';
    this.searchCriteria.emit(this.searchWord);
  }
}
